// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2Z9j2","vLegacy":"SelectSecondary_vLegacy__2_VJJ","error":"SelectSecondary_error__Tket8","disabled":"SelectSecondary_disabled__2RXEH"};